import React, {useContext, useEffect, useState} from 'react'
import axios from "axios";
import Image from "./Image";
import {formatDate, getBearerToken, getServerUrl} from "./utils/utils";
import {UserContext} from "./UserContext";
import TripPicturesSlideshowModal from "./TripPicturesSlideshowModal";

function TripPicturesSlideshow({trips, open, onLocationSelect}) {
    const { user } = useContext(UserContext)
    const [allImages, setAllImages] = useState([])
    const [allUserImages, setAllUserImages] = useState([])
    const [slideshowImageIds, setSlideshowImageIds] = useState([])
    const [slideshowImages, setSlideshowImages] = useState([])
    const [slideshowImageIndex, setSlideshowImageIndex] = useState(0)
    const [images, setImages] = useState([])
    const [allImagesLoaded, setAllImagesLoaded] = useState(false)
    const [interval, setNewInterval] = useState(null)
    const [intervalTwo, setIntervalTwo] = useState(null)
    const [selectedTripIndex, setSelectedTripIndex] = useState(0)
    const [selectedTripId, setSelectedTripId] = useState(null)
    const [tripEnded, setTripEnded] = useState(false)
    const [picturesLoading, setPicturesLoading] = useState(true)
    const [openModal, setOpenModal] = useState(false)
    const [slideshowSettings, setSlideshowSettings] = useState({})
    const [retrievingSlideshowImages, setRetrievingSlideshowImages] = useState(false)

    useEffect(() => {
        if (open && !images.length > 0) {
            setOpenModal(true)
        } else if (!open && images.length > 0) {
            clearInterval(interval)
            clearInterval(intervalTwo)
            setImages([])
            setAllImagesLoaded(false)
            setAllImages([])
            setSelectedTripId(null)
            setTripEnded(false)
            setSlideshowSettings({})
            setPicturesLoading(true)

        }
    }, [open, trips])

    useEffect(() => {
        if (Object.keys(slideshowSettings).length > 0 && slideshowSettings.type === 'Trips') {
            getTripImages(0)
        } else if (slideshowSettings.type === 'Photos' && allUserImages.length === 0) {
            getAllUserImages()
        } else if (slideshowSettings.type === 'Photos' && allUserImages.length > 0) {
            startScroll()
            setPicturesLoading(false)
            setSlideshowImageIds(getSlideshowImages().map(image => image.id))
        }

    }, [slideshowSettings, allUserImages])

    useEffect(() => {
        if (slideshowImageIds.length > 0 && slideshowImages.length === 0) {
            getImagesFromIdList(slideshowImageIds.slice(0,12), 0)
        }
    }, [slideshowImageIds])

    useEffect(() => {
        if (retrievingSlideshowImages){
            setSlideshowImageIndex(slideshowImageIndex => {
                return slideshowImageIndex + 12
            })
        }
    }, [retrievingSlideshowImages])

    useEffect(() => {
        if (slideshowImageIndex > 0){
            getImagesFromIdList(slideshowImageIds.slice(slideshowImageIndex, slideshowImageIndex + 12), slideshowImageIndex + 12)
        }
    }, [slideshowImageIndex, slideshowImageIds])

    useEffect(() => {
        if (tripEnded && interval) {
            setPicturesLoading(true)
            setImages([])
            setAllImages([])
            setSelectedTripId(null)
            clearInterval(interval)
            setTripEnded(false)
            setSelectedTripIndex(currentTripIndex => {
                getTripImages(currentTripIndex + 1)
                return currentTripIndex + 1
            })
        }
    }, [tripEnded, interval])

    useEffect(() => {
        if (selectedTripId && allImages?.length > 0 && images?.length > 0 && allImages?.length !== images.length){
            setTimeout(() => {
                retrieveImagesInBatches(selectedTripId, images?.length)
            }, 10000)
        }
            }, [images, allImages, selectedTripId])

    const getTrips = () => {
        if (slideshowSettings.type === 'Trips'){
            const filteredTrips = trips.filter(trip => {
                const tripMatchesCategory = (!slideshowSettings.category || trip.category === slideshowSettings.category)
                const tripIsInDateRange = (slideshowSettings.filter !== 'Year' ||
                    (Number(trip.startDate.split("-")[0]) >= slideshowSettings.startYear
                    && Number(trip.endDate.split("-")[0]) <= slideshowSettings.endYear))
                const tripMeetsFriendsRequirements = !slideshowSettings.friends?.length > 0 || slideshowSettings.friends.every(friend => {
                    return !!trip?.taggedUsers?.find(taggedUser => taggedUser.user.username === friend)
                })
                const tripMeetsUploadUserTypeRequirements = slideshowSettings.uploadUserType === 'all' || trip.user.id === user.id
                return tripMatchesCategory && tripIsInDateRange && tripMeetsFriendsRequirements && tripMeetsUploadUserTypeRequirements
            })
            if (slideshowSettings.tripOrder === 'random'){
                return filteredTrips
            } else if (slideshowSettings.tripOrder === 'recent'){
                return filteredTrips.sort((a,b) => new Date(b.startDate) - new Date(a.startDate))
            } else {
                return filteredTrips.sort((a,b) => new Date(a.startDate) - new Date(b.startDate))

            }
        }
    }

    const getSlideshowImages = () => {
        const filteredImages = allUserImages.filter(image => {
            const tripMatchesCategory = (!slideshowSettings.category || image.trip.category === slideshowSettings.category)
            const tripIsInDateRange = (slideshowSettings.filter !== 'Year' ||
                (Number(image.trip.startDate.split("-")[0]) >= slideshowSettings.startYear
                    && Number(image.trip.endDate.split("-")[0]) <= slideshowSettings.endYear))
            const tripMeetsFriendsRequirements = !slideshowSettings.friends?.length > 0 || slideshowSettings.friends.every(friend => {
                return !!image.trip?.taggedUsers?.find(taggedUser => taggedUser.user.username === friend)
            })
            const tripMeetsUploadUserTypeRequirements = slideshowSettings.uploadUserType === 'all' || image.user.id === user.id
            return tripMatchesCategory && tripIsInDateRange && tripMeetsFriendsRequirements && tripMeetsUploadUserTypeRequirements
        })
        if (slideshowSettings.tripOrder === 'random'){
            return filteredImages.map(value => ({value, sort: Math.random()}))
                .sort((a, b) => a.sort - b.sort)
                .map(({value}) => value)
        } else if (slideshowSettings.tripOrder === 'recent'){
            return filteredImages.sort((a,b) => new Date(b.trip.startDate) - new Date(a.trip.startDate))
        } else {
            return filteredImages.sort((a,b) => new Date(a.trip.startDate) - new Date(b.trip.startDate))

        }
    }

    const getTripImages = async tripIndex => {
        setImages([])
        const filteredTrips = getTrips()
        if (tripIndex < filteredTrips.length) {
            const selectedTrip = filteredTrips[tripIndex]
            onLocationSelect(selectedTrip.location)
            setSelectedTripId(selectedTrip?.id)
            retrieveImagesInBatches(selectedTrip?.id, 0)
        }
    }

    const getAllUserImages = async () => {
        axios.get(`${getServerUrl()}/images`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setAllUserImages(response.data)
            })
    }

    const getImagesFromIdList = async (imageIds, index) => {
        axios.post(`${getServerUrl()}/images/ids`, {
            imageIds
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`
            }
        })
            .then(response => {
                if (index === 0){
                    startScroll()
                    setPicturesLoading(false)
                    setSlideshowImages(response.data)
                } else {
                    setRetrievingSlideshowImages(false)
                    setSlideshowImages(currentSlideshowImages => {
                        const updatedSlideshowImages = [...currentSlideshowImages]
                        updatedSlideshowImages.push(...response.data)
                        return updatedSlideshowImages
                    })
                }
            })
    }

    const retrieveImagesInBatches = async (selectedTripId, startIndex) => {
        axios.get(`${getServerUrl()}/trip/${selectedTripId}/images?loadCoverImage=true&shortenVideo=true&loadAsBatch=true&batchLoadIndex=${startIndex}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                if (startIndex === 0){
                    startScroll()
                    setAllImages(response.data)
                    setPicturesLoading(false)
                }
                const newImages = response.data.slice(0, response.data.length > 12 ? 12 : response.data.length)
                if (startIndex === 0) {
                    setImages(newImages)
                } else {
                    setImages(currentImages => {
                        const updatedCurrentImages = [...currentImages]
                        updatedCurrentImages.push(...newImages)
                        return updatedCurrentImages
                    })


                }
            })
    }

    const startScroll = tripIndex => {
        const slideShowContainer = document.getElementById('picture-slideshow-container');
        const slideShowScrollWidth = slideShowContainer.scrollWidth;
        const newInterval = setInterval(() => {
            // if (slideShowContainer.scrollLeft !== slideShowScrollWidth) {
                slideShowContainer.scrollTo(slideShowContainer.scrollLeft + 1, 0);
        }, 10);
        setNewInterval(newInterval)
        const newIntervalTwo = setInterval(() => {
            // if (slideShowContainer.scrollLeft !== slideShowScrollWidth) {
            const pictures = document.getElementsByClassName('picture-slideshow-div')
            let numPicturesOutOfScreen = 0
            if (pictures) {
                for (let i = 0; i < pictures.length; i++) {
                    const picture = pictures[i]
                    const pictureLocation = picture.getBoundingClientRect();
                    if (pictureLocation.right < 0) {
                        numPicturesOutOfScreen++
                        if (numPicturesOutOfScreen === pictures.length && slideshowSettings.type === 'Trips') {
                            setTripEnded(true)
                        }
                        //works for hiding photos, not for images
                        const img = picture.children[0].children[0]
                        const imageSrc = img.getAttribute("src")
                        if (imageSrc && !imageSrc.includes(".mp4")) {
                            const imageRect = img.getBoundingClientRect();
                            img.setAttribute("height", imageRect.height + "px")
                            img.setAttribute("width", imageRect.width + "px")
                            img.setAttribute("src", "")
                        }
                    }
                }
                if (slideshowSettings.type === 'Photos') {
                    let numPicturesOutOfScreenRight = 0
                    for (let i = 0; i < pictures.length; i++) {
                        const picture = pictures[i]
                        const pictureLocation = picture.getBoundingClientRect();
                        if (pictureLocation.left > window.innerWidth) {
                            numPicturesOutOfScreenRight++
                        }
                    }
                    if (numPicturesOutOfScreenRight === 2 && !retrievingSlideshowImages) {
                        setRetrievingSlideshowImages(currentRetrievingSlideshowImages => {
                            if (!currentRetrievingSlideshowImages){
                                return true
                            } else {
                                return false
                            }
                        })
                    }
                }
            }
            // } else {
            //     setTripEnded(true)
            // }
        }, 500);
        setIntervalTwo(newIntervalTwo)
        setAllImagesLoaded(true)
    }

    const handleModalClose = slideshowSettingsObject => {
        setOpenModal(false)
        setSlideshowSettings(slideshowSettingsObject)
    }


    const imageList = slideshowSettings?.type === 'Trips' ? images.filter(image => image.image_location || image.video_location)
        : slideshowImages.filter(image => image.image_location || image.video_location)

    const filteredTrips = getTrips()

    const shouldShowPhotoSlideshowTitle = slideshowSettings.type === 'Photos' && slideshowSettings.shouldShowSlideshowTitle === 'yes'

    const showFullscreenImage = slideshowSettings.type === 'Photos' && slideshowSettings.shouldShowSlideshowTitle

    if (open) {
        const imageDisplayList = imageList.slice(0, imageList.length).map((image, index) => (
            <div
                className={`picture-slideshow-div ${index === 0 ? "zero" : ""} ${index === imageList.length - 1 ? "last" : ""} index-${index}`}
                style={!allImagesLoaded ? {visibility: "hidden"} : {}}>
                <Image imageFile={image} onClick={() => {}} imageIdsForNewActivity={[]}
                       key={image.id} hideVisibilitySensor={true} showVideoCoverImage={false} playWhenVisible={true}/>
            </div>
        ))
        return (
            <>
                {(filteredTrips?.length > 0 && !picturesLoading) && (
                    <div id="trip-title-container">
                        <h1  style={picturesLoading ? {opacity: 0} : {}}>{filteredTrips[selectedTripIndex].name}</h1>
                        <h3>{`${filteredTrips[selectedTripIndex].location}  |  ${formatDate(filteredTrips[selectedTripIndex].startDate)} - ${formatDate(filteredTrips[selectedTripIndex].startDate)}`}</h3>
                    </div>
                )}
                {shouldShowPhotoSlideshowTitle && (
                    <div id="trip-title-container">
                        <h1>{slideshowSettings.slideshowTitle}</h1>
                    </div>
                )}
                <div id="picture-slideshow-container"
                     className={showFullscreenImage ? "fullscreen-image-slideshow-div" : "trip-slideshow-div" }
                >
                    {imageDisplayList}
                </div>
                {tripEnded && (
                    <div id="trip-title-container">
                        <h1> Finished </h1>
                    </div>

                )}
                <TripPicturesSlideshowModal open={openModal} onClose={handleModalClose} />
            </>
        )
    }

    return null
}

export default TripPicturesSlideshow;